import React from 'react';
import './Button.css'
import Arrow from '../../Assets/Arrow.svg'

const Button = (props) => {
    return ( 
        <>
        <button>
            <div className='button_div'>
                <h6 className="button_text">{props.text}</h6>
                <img className='button_icon' src={Arrow} alt="" />
            </div>
        </button>
        </>
     );
}
 
export default Button;